<template>
  <div :class="[style['bottom-panel'], { [style['bottom-panel-date-range']]: useDateRange }]">
    <datepicker
      v-model="selectedDate"
      :disabled-dates="disabledDates"
      :enabled-dates="enabledDates"
      :date-picker-widget-id="datePickerWidgetId"
      :language="computedDateLanguage"
      :use-date-range="useDateRange"
      @selected="handleSelectDate"
    />
    <panel-control
      :close-only="isUsedForFormTemplate"
      @bottomPanelSend="bottomPanelSend"
      @bottomPanelSelect="bottomPanelSelect"
      @bottomPanelForm="bottomPanelForm"
    />
  </div>
</template>

<script>
import Datepicker from '../Components/Datepicker/components/Datepicker.vue'
import PanelControl from '../Components/PanelControl.vue'
import DateEN from '../Components/Datepicker/locale/translations/en'
import DateJA from '../Components/Datepicker/locale/translations/ja'
import DateZH from '../Components/Datepicker/locale/translations/zh'
import DateKO from '../Components/Datepicker/locale/translations/ko'
import { EventBus } from 'ChatWidget/EventBus'
import { Chat } from 'src/apis'
import style from '../scss/_bottompanel.scss'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'
import { useFormStore } from 'Store/form'

export default {
  components: {
    Datepicker,
    PanelControl
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore(),
      formStore: useFormStore()
    }
  },

  props: {
    disabledDates: Object,
    enabledDates: Object
  },
  data() {
    return {
      datePickerWidgetId: this.datepickerStore.settings.datePickerWidgetId,
      style
    }
  },
  computed: {
    selectedDate: {
      get() {
        return this.datepickerStore.settings.currentDate || ''
      },

      set(val) {
        this.datepickerStore.setTimeSettings({
          ...this.datepickerStore.settings,
          currentDate: val
        })
      }
    },

    isUsedForFormTemplate() {
      return this.bottomPanelStore.inputFor === 'TemplateForm'
    },

    computedDateLanguage() {
      switch (this.$i18n.locale) {
        case 'en':
          return DateEN
        case 'ja':
          return DateJA
        case 'zh_Hans':
          return DateZH
        case 'zh_Hant':
          return DateZH
        case 'ko':
          return DateKO
        default:
          return DateEN
      }
    },
    /**
     * return the date-wise inventory count
     * @return {Object || null}
     */
    inventory() {
      return this.datepickerStore.inventory
    },
    useDateRange() {
      return !!this.datepickerStore.useDateRange
    }
  },
  methods: {
    handleSelectDate() {
      if (this.isUsedForFormTemplate) {
        this.bottomPanelStore.setBottomPanelComponent()
      }
    },

    bottomPanelSend() {
      // disable the date widget in ChatWidget/ChatWindow/Chats/DateWidget.vue
      if (this.datePickerWidgetId) EventBus.$emit('disableDateWidget', this.datePickerWidgetId)
      Chat.sendMessage(this.selectedDate)
      this.bottomPanelStore.setBottomPanelComponent()
    },
    bottomPanelSelect() {
      const dateRange = this.datepickerStore.dateRange
      this.reservationFormStore.setReservationFormDates({
        startDate: dateRange.checkIn,
        endDate: dateRange.checkOut
      })
      this.bottomPanelStore.setBottomPanelComponent()
    },
    bottomPanelForm() {
      this.formStore.setFormFieldValue(this.selectedDate)
      this.bottomPanelStore.setBottomPanelComponent()
    }
  }
}
</script>
